module.exports = __webpack_public_path__ + "img/3.78c39dc3.svg";